var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import TextField from "../../../Form/TextField";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import DateService from "../../../../Services/Shared/Date.service";
import RuleSetService from "../../../../Services/RuleSet.service";
import { getRuleSetCreatePath, getRuleSetDetailPath, } from "./AdminDuplicateDetectionRoutes";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import { SecondaryNavLink, } from "../../../UI/SecondaryNav/SecondaryNavButton";
import useService from "../../../Hooks/useService";
const StatusColor = (active) => {
    const color = active ? "success" : "dark";
    const text = active ? "Yes" : "No";
    return _jsx("span", { className: `badge badge-${color} px-1`, children: text });
};
const PAGE_SIZE = 50;
const RuleSetTable = () => {
    const [searchArgs, setSearchArgs] = React.useState({
        query: "",
    });
    const { table } = usePagedSortedTable({
        searchArgs,
        hover: true,
        striped: true,
        noDataComponent: "No Rule Sets found",
        getNumPages: (result) => 
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        getData: (sort, pageNumber, sArgs) => {
            return RuleSetService.search(Object.assign({}, sArgs), {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
            });
        },
        columns: [
            { title: "Name", sortId: "RULE_SET_NAME" },
            { title: "Created By", sortId: "RULE_SET_CREATED_BY" },
            { title: "Created Date", sortId: "RULE_SET_CREATED_DATE" },
            { title: "Modified By", sortId: "RULE_SET_MODIFIED_BY" },
            { title: "Modified Date", sortId: "RULE_SET_MODIFIED_DATE" },
            { title: "Active", sortId: "RULE_SET_ACTIVE" },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => data.map((ruleSet) => [
            _jsx(Link, { to: getRuleSetDetailPath(ruleSet.id), children: ruleSet.name }, ruleSet.id),
            ruleSet.createdBy.fullName,
            DateService.displayWithTime(ruleSet.createdDate),
            ruleSet.modifiedBy.fullName,
            DateService.displayWithTime(ruleSet.modifiedDate),
            StatusColor(ruleSet.active),
        ]),
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "mb-3", children: _jsx(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                        setSearchArgs({
                            query: formState.query,
                        });
                    }), children: _jsx(TextField, { name: "query", label: "Search Name" }) }) }), _jsx("div", { className: "py-2", children: table })] }));
};
const DuplicateDetectionIndex = () => {
    const [ruleSetCountState, loadRuleSetCount] = useService(RuleSetService.ruleSetCount);
    React.useEffect(() => {
        loadRuleSetCount();
    }, [loadRuleSetCount]);
    const newIsDisabled = !!(ruleSetCountState === null || ruleSetCountState === void 0 ? void 0 : ruleSetCountState.data) && ruleSetCountState.data > 1;
    return (_jsxs(_Fragment, { children: [_jsx(SecondaryNavLayout, { dontAddSpacer: true, nav: _jsx("div", { className: "d-flex", children: _jsx(SecondaryNavLink, { icon: "plus", title: newIsDisabled
                            ? "You can only have up to two Rule Sets"
                            : "Create a new Rule Set", label: "New", to: getRuleSetCreatePath(), 
                        // @ts-expect-error - TS2322 - Type '{ key: string; icon: string; title: string; label: string; to: string; disabled: boolean; }' is not assignable to type 'IntrinsicAttributes & Props & { to: string; }'.
                        disabled: newIsDisabled }, "new") }) }), _jsxs("div", { className: "container-fluid mt-3", children: [_jsx("h1", { className: "mt-3", children: "Duplicate Detection Rule Sets" }), _jsx(RuleSetTable, {})] })] }));
};
export default DuplicateDetectionIndex;
